/* eslint-disable max-len */
export const common = {
  'pd-processing-policy-file-name': 'pd_processing_policy_uz.pdf',
  'user-agreement-sm-podbor-file-name-ru': 'user_agreement_sm_podbor_uz_ru.pdf',
  'user-agreement-sm-podbor-file-name': 'user_agreement_sm_podbor_uz.pdf',
  yes: 'Ha',
  no: 'Yoʻq',
  'accept-agreement-to-continue': 'Davom ettirish uchun maʼlumotlarni qayta ishlashga rozilik berish lozim',
  'i-accept-user-data-proccesing': 'Shaxsga doir maʼlumotlarimni qayta ishlashga rozilik beraman',
  continue: 'Davom etish',
  start: 'Boshlash',
  skip: 'Davom etish',
  delete: 'Oʻchirish',
  cancel: 'Bekor qilish',
  registration: 'Roʻyxatdan oʻtish',
  russia: 'Rossiya',
  ukraine: 'Ukraina',
  belarus: 'Belarus',
  'cookie-agreement': 'Takliflarni ehtiyojlaringizga muvofiq moslashtirish va sayt bilan oʻzaro munosabatlarda maksimal qulaylikni taʼminlash uchun cookie fayllardan foydalanamiz. <a href="/user_agreement_sm_podbor_uz.pdf" target="_blank" class="text-neutral-700 hover:underline">Cookie fayllardan foydalanish haqida batafsil. </a>Saytdan foydalanishda davom etish orqali cookie fayllardan foydalanishga rozilik berasiz.',
  'accept-and-close': 'Qabul qilish va yopish',
  'action-confirmation': 'Amalni tasdiqlash',
  'execute-action': 'Amal bajarilsinmi?',
  ok: 'OK',
  'choose-date': 'Sanani tanlang',
  'birth-date': 'Tugʻilgan sana',
  'add-resume': 'Rezyume qoʻshing',
  'invalid-file-type': 'Ruxsat etilmagan fayl turi',
  'cannot-load-stores': 'Doʻkon maʼlumotlari yuklanmadi. Administratorlarga murojaat qiling.',
  'nothing-found': 'Hech narsa topilmadi',
  'store-business-card': 'Doʻkon tashrifnomasi',
  'date-time-creation': 'Yaratilgan sana/vaqt',
  vacancy: 'Vakansiyalar',
  store: 'Do‘kon',
  'file-upload-error': 'Faylni yuklashda xatolik. Qayta urining',
  'file-remove-error': 'Faylni oʻchirib yuborishda xatolik. Qayta urining',
  'file-upload-success': 'Fayl muvaffaqiyatli yuklandi',
  'file-remove-success': 'Fayl muvaffaqiyatli oʻchirib yuborildi',
  'file-already-uploaded': 'Siz bu faylni yuklab boʻldingiz',
};
